import {
    ConversationsAction,
    CurrentConversationState,
} from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import { Thunk } from "utilities/atoms/atom-with-thunks-reducer";

export const cancelPrompt =
    (): Thunk<CurrentConversationState, ConversationsAction> =>
    async (dispatch, getState) => {
        const { streamingResponseAbortController: abortController } =
            getState();

        if (abortController) {
            abortController.abort();
        }

        dispatch({ type: "CANCEL_PROMPT" });
    };
